import nl2br from 'nl2br';

/**
* Request AI generation for a Post ID
*/

$(window).on('load', function() {

	// Generate AI content

	$( document ).on( 'click', '[data-generate-prompt]', function(e) {

		e.preventDefault();

		let button = $(this);
		let post_id = $(this).data('generate-prompt');

		// Disable button to show progress

		button.prop('disabled', true);

		$.post(app.ajaxurl,
		{
			action: 'generate_ai_prompt',
			post_id: post_id,
		},
		function(data, status){
		
			$('.modal__title', '[data-modal="ai-content"]').val('').show();
			$('.modal__content', '[data-modal="ai-content"]').html('').show();
			$('.modal__image', '[data-modal="ai-content"]').html('').show();
			$('.modal__instructions', '[data-modal="ai-content"]').html('').show();
			$('.modal__usage', '[data-modal="ai-content"]').html('').show();
			$('[data-ai-action]', '.modal__actions').hide();

			if (data.success)
			{
				$('.modal__title', '[data-modal="ai-content"]').val(data.title);
				$('.modal__image', '[data-modal="ai-content"]').val(data.image);
				$('.modal__content', '[data-modal="ai-content"]').html(data.content);
				$('.modal__instructions', '[data-modal="ai-content"]').html(data.instructions);
				$('.modal__usage', '[data-modal="ai-content"]').html('API requests this month: ' + data.usage);

				$(data.actions).each(function(index, value) {
					let name = value.charAt(0).toUpperCase() + value.slice(1);

					if (name == 'Copy')
					{
						name = 'Copy to Clipboard';
					}

					let action_button = $('[data-ai-action="'  + value + '"]', '.modal__actions');
					action_button.fadeIn();
					action_button.data('related-post-id', post_id);
					action_button.prop('disabled', false).html(name);
				});

			}
			else
			{
				$('.modal__title', '[data-modal="ai-content"]').hide();
				$('.modal__content', '[data-modal="ai-content"]').hide();
				$('.modal__image', '[data-modal="ai-content"]').show();
				$('.modal__instructions', '[data-modal="ai-content"]').html(data.message);
				$('.modal__usage', '[data-modal="ai-content"]').hide();
			}

			$('[data-modal="ai-content"]').removeClass('is-hidden').fadeIn();

			button.prop('disabled', false);

		}, 'json');

	});

	// Add AI content to article

	$( document ).on( 'click', '[data-ai-action="add"]', function() {

		// Create another story box on the end of the list

		$('[data-repeater="add-story"]').get(0).click();

		let title = $('.modal__title', '[data-modal="ai-content"]').val();
		let image = $('.modal__image', '[data-modal="ai-content"]').val();
		let content = $('.modal__content', '[data-modal="ai-content"]').html();

		let item = $('.user-article').last();
		let editor_id = $('iframe', item).prop('id').replace('_ifr', '');

		// Populate title and TinyMCE content field

		$('[name^="newsletter_user_article[title]"]', item).val(title);

		tinyMCE.get(editor_id).setContent( nl2br(content) );

		// Hide modal

		$('[data-modal="ai-content"]').addClass('is-hidden').fadeOut();

	});

	// Save AI content as a new post

	$( document ).on( 'click', '[data-ai-action="save"]', function() {

		let modal = $('[data-modal="ai-content"]');
		let post_type = modal.data('post_type');
		let title = $('.modal__title', modal).val();
		let content = $('.modal__content', modal).val();
		let related_post_id = $(this).data('related-post-id');
		let edit_post_id = $(this).data('edit-post-id');

		let button = $(this);

		button.prop('disabled', true);

		$.post(app.ajaxurl,
		{
			action: 'save_ai_content',
			post_type: post_type,
			related_post_id: related_post_id,
			edit_post_id: edit_post_id,
			title: title,
			content: content,
		},
		function(data, status){

			button.html('Saved!');

			setTimeout(function() {
				// If we've just created a new post, keep the button disabled, otherwise re-enable it after a short delay
				if (edit_post_id)
				{
					button.prop('disabled', false).html('Save');
				}
			}, 2000);

		});

	});

	// Copy AI content to clipboard

	$( document ).on( 'click', '[data-ai-action="copy"]', function() {
		
		const button = $(this);

	  	// Get the text field
		let title = $('.modal__title', '[data-modal="ai-content"]').val();
		let content = $('.modal__content', '[data-modal="ai-content"]').html();

		let copyText = title + '\n\n' + content;

		// Copy the text inside the text field
		navigator.clipboard.writeText(copyText);

		button.html('Copied!');

		setTimeout(function() {
			button.html('Copy to Clipboard');
		}, 3000);

	});

	// View previously generated versions of a post

	$( document ).on( 'click', '[data-show-versions]', function(e) {

		e.preventDefault();

		let button = $(this);
		let modal = $('[data-modal="ai-versions"]');
		let post_id = $(this).data('show-versions');
		let post_type = modal.data('post_type');

		// Disable button to show progress

		button.prop('disabled', true);

		$.post(app.ajaxurl,
		{
			action: 'retrieve_ai_versions',
			post_id: post_id,
			post_type: post_type,
		},
		function(data, status){
		
 			$('.modal__instructions', modal).html(data.instructions);

 			let dropdown = $('.modal__dropdown');
 			let action_button = $('[data-ai-action="edit"]');

 			dropdown.hide();
 			action_button.hide();

 			if (data.posts.length)
 			{

				$.each(data.posts, function() {
				    dropdown.append($('<option />').val(this.id).text(this.post_title));
				});

				action_button.on('click', function() {

					let edit_post_id = dropdown.val();

					if (edit_post_id)
					{

						$.post(app.ajaxurl,
						{
							action: 'retrieve_ai_version',
							post_id: edit_post_id,
							post_type: post_type,
						},
						function(data, status){

							let edit_modal = $('[data-modal="ai-content"]');
						
							$('.modal__title', edit_modal).val('').show();
							$('.modal__content', edit_modal).html('').show();
							$('.modal__instructions', edit_modal).html('').show();
							$('[data-ai-action]', edit_modal).hide();

							if (data.success)
							{
								$('.modal__title', edit_modal).val(data.title);
								$('.modal__content', edit_modal).html(data.content);
								$('.modal__instructions', edit_modal).html(data.instructions);

								$(data.actions).each(function(index, value) {
									let name = value.charAt(0).toUpperCase() + value.slice(1);
									let action_button = $('[data-ai-action="'  + value + '"]', '.modal__actions');

									if (name == 'Copy')
									{
										name = 'Copy to Clipboard';
									}

									action_button.prop('disabled', false).html(name);
									action_button.data('edit-post-id', edit_post_id);
									action_button.data('related-post-id', null);
									action_button.fadeIn();
								});

							}

							modal.removeClass('is-hidden').fadeOut(function() {
								edit_modal.removeClass('is-hidden').fadeIn();
							});

							button.prop('disabled', false);

						}, 'json');

					}

				});

				dropdown.show();
				action_button.show();

			}

			$('[data-modal="ai-versions"]').removeClass('is-hidden').fadeIn();

			button.prop('disabled', false);

		}, 'json');

	});

});